import { CheckboxGroup } from '@pwc/pwc-deals-ui';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getSurveyResponses } from '../../../surveySlice';
import { validate } from '../../../common/services/utilities/surveyUtility';

const toggleOption = (selectedOption, options) => {
  return options.map((option) => {
    const currentOption = { ...option };
    currentOption.selected =
      currentOption.value === selectedOption.value
        ? !currentOption.selected
        : currentOption.selected;
    return currentOption;
  });
};

const formatOptions = (options) =>
  options
    ? options.map((option) => ({
        label: option.text,
        value: `${option.id}`,
        selected: false,
      }))
    : [];

const QuestionMultiselect = ({
  question,
  userAnswer,
  setUserAnswer,
  setIsAnswerValid,
}) => {
  const [options, setOptions] = useState([]);

  const responses = useSelector(getSurveyResponses);

  useEffect(() => {
    const answers =
      responses &&
      responses.answers.filter((ans) => ans.questionId === question.id);
    let tempOptions = formatOptions(question.options);
    if (answers.length) {
      answers.forEach((answer) => {
        const selectedOption = tempOptions.find(
          (option) => +option.value === answer.optionId
        );
        tempOptions = toggleOption(selectedOption, tempOptions);
      });
    }
    setOptions(tempOptions);
  }, [setUserAnswer, responses, question.id, question.options]);

  useEffect(() => {
    const { isValid } = validate.questionMultiselect(userAnswer);
    setIsAnswerValid(isValid);
  }, [userAnswer, setIsAnswerValid, setUserAnswer]);

  useEffect(() => {
    const selectedOptionValues = options
      .filter((option) => option.selected)
      .map((option) => +option.value);
    setUserAnswer(selectedOptionValues);
  }, [options, setUserAnswer]);

  return (
    options && (
      <CheckboxGroup
        name={`multiselect-${question.id}`}
        label={question.text}
        options={options}
        onChange={(selectedOption) => {
          const updatedOptions = toggleOption(selectedOption, [...options]);
          setOptions(updatedOptions);
        }}
      />
    )
  );
};

export default QuestionMultiselect;
